import { ColorEnum } from '@/constants/color'
import Description from '@/features/notifications/components/Notification/parts/Description'
import IconContainer from '@/features/notifications/components/Notification/parts/IconContainer'
import { useEnabledButtonState } from '@/features/ui/buttons/hooks/useEnabledButtonState'
import { isInteractiveButtonState } from '@/features/ui/buttons/utils'
import { hexToRgba } from '@/utils/hexToRgba'
import { Pressable, PressableProps, StyleProp, ViewStyle } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface NotificationProps extends PressableProps {
    style?: StyleProp<ViewStyle>
}

const Notification = ({ children, style, ...props }: NotificationProps) => {
    const { state, eventHandlers } = useEnabledButtonState()

    const { styles } = useStyles(stylesheet, {
        state: isInteractiveButtonState(state) ? state : undefined,
    })

    return (
        <Pressable {...props} {...eventHandlers} style={[styles.container, style]}>
            {children}
        </Pressable>
    )
}

const stylesheet = createStyleSheet({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        variants: {
            state: {
                hovered: {
                    backgroundColor: hexToRgba(ColorEnum.JET_900, 0.0625),
                },
                pressed: {
                    backgroundColor: hexToRgba(ColorEnum.JET_900, 0.25),
                },
            },
        },
    },
})

Notification.Description = Description
Notification.IconContainer = IconContainer

export default Notification
